let current;
const buttons = document.querySelectorAll(".lp-beauty-products .js-modal");
if (buttons.length) {
  buttons.forEach(elm => {
    elm.addEventListener("click", (event) => {
      if (!current) {
        current = event.target.nextElementSibling;
        current.classList.add("is-open");
        let position = current.getBoundingClientRect().top + window.pageYOffset;
        console.log(position);
        window.scroll({
          top: position,
          behavior: "smooth"
        });
      }
    })
  })
}

const closeButtons = document.querySelectorAll(".lp-beauty-products .js-modal-close");
if (closeButtons.length) {
  closeButtons.forEach(elm => {
    elm.addEventListener("click", () => {
      if (current) {
        current.classList.remove("is-open");
        current = null;
      }
    })
  });
}
